import React from 'react';
import { RedemptionSuccessContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { CONSUMER_ROUTE_PATH } from 'utils/constants/routePath';
import { Tables, Icons, Displays, Inputs } from 'components';
import { retailerService } from 'apiServices';
import { RenderCommaMoney } from 'utils/functions/FormatMoney';
import { RenderSortTable } from 'utils/functions/SortTable';
import { setReduxDataShop } from 'store/actions';
import { connect } from 'react-redux';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import moment from 'moment';
import {
  parseFilterFromSearchParams,
  buildApiQueryString,
  mergeFilterIntoParams,
  legacyQueryStringToObject,
  clearFilterParams,
} from 'utils/functions/filterUrl';

const API_EXTRA = {
  memberType: '2',
  status_key: 'success',
  date_type: 'updated_at',
};

const todayStr = () => moment().format('YYYY-MM-DD');

class RedemptionSuccessContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    isLoadingTable: true,
    sortTable: {
      reward_name: 1,
      totalCount: 1,
    },
  };

  componentDidMount() {
    scrollToTopPageFN();
    const { searchParams, setSearchParams } = this.props.router;
    const needsSeed =
      !searchParams.get('limit') || !searchParams.get('start_date');
    if (needsSeed) {
      const sp = new URLSearchParams(searchParams);
      if (!sp.get('limit')) sp.set('limit', '10');
      if (!sp.get('page')) sp.set('page', '1');
      if (!sp.get('start_date')) sp.set('start_date', todayStr());
      if (!sp.get('end_date')) sp.set('end_date', todayStr());
      setSearchParams(sp, { replace: true });
      this.fetchData(buildApiQueryString(sp, { extra: API_EXTRA }));
    } else {
      this.fetchData(buildApiQueryString(searchParams, { extra: API_EXTRA }));
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.router.location.search !== this.props.router.location.search
    ) {
      this.setState({ isLoadingTable: true });
      this.fetchData(
        buildApiQueryString(this.props.router.searchParams, { extra: API_EXTRA })
      );
    }
  }

  ensureDateDefaults = (sp) => {
    if (!sp.get('start_date')) sp.set('start_date', todayStr());
    if (!sp.get('end_date')) sp.set('end_date', todayStr());
    return sp;
  };

  handlePageClick = (e) => {
    const sp = new URLSearchParams(this.props.router.searchParams);
    sp.set('page', String(e.selected + 1));
    this.props.router.setSearchParams(this.ensureDateDefaults(sp));
  };

  handleFilterSelect = (legacyQs) => {
    const patch = legacyQueryStringToObject(legacyQs);
    const sp = mergeFilterIntoParams(this.props.router.searchParams, patch, {
      resetPage: true,
    });
    this.props.router.setSearchParams(this.ensureDateDefaults(sp));
  };

  handleClearFilter = () => {
    const sp = clearFilterParams(this.props.router.searchParams, dataFilter);
    sp.set('start_date', todayStr());
    sp.set('end_date', todayStr());
    this.props.router.setSearchParams(sp);
  };

  fetchData = async (stringQuery) => {
    let res =
      await retailerService.GET_WHEEL_GAME_REWARD_ON_PROCESS_RETAILER_LIST(
        stringQuery
      );

    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
        isLoading: false,
        isLoadingTable: false,
      });
    }
  };

  handleClickItem = (e) => {
    this.props.setReduxDataShop(e._id.reward_name);
    this.props.router.navigate(
      `${CONSUMER_ROUTE_PATH.REDEMPTION_SUCCESS}/${e._id.reward_ref_id}`
    );
  };

  handleSort = (e) => {
    const { data, sortTable } = this.state;

    if (data && data.length > 0) {
      let sortValue;
      switch (e) {
        case 'reward_name_group':
          sortValue = RenderSortTable(e, data, sortTable.reward_name);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              reward_name: sortValue.sortNumber,
            },
          });

          break;

        case 'totalCount':
          sortValue = RenderSortTable(e, data, sortTable.totalCount);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              totalCount: sortValue.sortNumber,
            },
          });

          break;

        default:
          break;
      }
    }
  };

  render() {
    const { isLoading, data, pagination, isLoadingTable } = this.state;
    const { searchParams } = this.props.router;
    const { filterValues } = parseFilterFromSearchParams(
      searchParams,
      dataFilter,
      { defaultLimit: 10 }
    );
    return (
      <RedemptionSuccessContainerStyled>
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading />
          </div>
        ) : (
          <>
            <div className="title_show">Redemption success</div>
            <div className="title_show">
              <Inputs.InputFilter
                theme_standard_input_filter
                dataFilter={dataFilter}
                btnLabel="เลือก"
                initialValues={filterValues}
                onQueryFilter={this.handleFilterSelect}
                onClear={this.handleClearFilter}
              />
            </div>
            <div className="title_show">
              <Tables.TableNormal
                theme_standard_table_normal
                showPagination
                useNo
                data={data}
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                isLoading={isLoadingTable}
                columns={columns13({
                  onClickItem: this.handleClickItem,
                  onSort: this.handleSort,
                })}
              />
            </div>
          </>
        )}
      </RedemptionSuccessContainerStyled>
    );
  }
}

const dataFilter = [
  {
    accessor: 'dateBy',
    placeHolder: 'ระยะเวลา',
    filter: {
      fieldQuery: 'types',
      type: 'dateGroup',
      placeholder: 'วันนี้',
      initialValues: { level1: 'day' },
      options: [
        { label: 'วันนี้', value: 'day' },
        { label: 'เดือนนี้', value: 'month' },
        { label: 'ไตรมาส', value: 'quarter' },
        { label: 'ระหว่างวันที่', value: 'date_range' },
      ],
    },
  },
  {
    accessor: 'rewardBy',
    length: '311px',
    filter: {
      fieldQuery: 'reward_name',
      type: 'text',
      placeholder: 'ค้นหาชื่อรางวัล',
    },
  },
];

const columns13 = ({ onClickItem, onSort }) => [
  {
    title: 'ลำดับ',
    field: 'no',
    headerStyle: { textAlign: 'center', width: '50px', flexShrink: 0 },
    style: { textAlign: 'center', width: '50px', flexShrink: 0 },
  },
  {
    title: (
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
        ชื่อของรางวัล
        <div
          style={{ marginLeft: '8px', display: 'flex' }}
          onClick={() => onSort('reward_name_group')}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: '_id.reward_name',
    headerStyle: { textAlign: 'left' },
    style: { textAlign: 'left' },
    render: ({ origin, value }) => <div>{value}</div>,
  },
  {
    title: (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        ส่งสำเร็จ
        <div
          style={{ marginLeft: '8px', display: 'flex' }}
          onClick={() => onSort('totalCount')}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: 'totalCount',
    headerStyle: {
      display: 'flex',
      justifyContent: 'center',
      width: '130px',
      flexShrink: 0,
    },
    style: { textAlign: 'right', width: '130px', flexShrink: 0 },
    render: ({ origin, value }) => (
      <div
        style={{ textDecoration: 'underline' }}
        onClick={() => onClickItem(origin)}
      >
        {RenderCommaMoney(Number(value), true)}
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setReduxDataShop: (data) => dispatch(setReduxDataShop(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RedemptionSuccessContainer));
